import React from "react";
import "./sectionHeader.scss";

export const SectionHeader = ({ children }) => {
  return <div className="section-header">{children}</div>;
};
